module.exports = __webpack_public_path__ + "static/media/bluf.15d997c6.JPG";